<div class="card card-login">
  <div class="card-content">
    <div class="row">
      <div class="container-fluid">
        <div class="login-header text-center">
          <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
          <h3>Reset password</h3>
        </div>
      </div>
    </div>


    <ng-container *ngIf="!linkValidity">
      <div class="login-header text-center">
        <h3 >This link has already been used. Please contact your administrator.</h3>
      </div>
    </ng-container>

    <ng-container *ngIf="linkValidity && passwordResetForm">
      <form [formGroup]='passwordResetForm'>

        <div class="input-group">
        <span class="input-group-addon">
          <i class="material-icons">account_box</i>
        </span>
          <div class="form-group label-floating">
            <label class="control-label">Username</label>
            <input type="text" class="form-control" formControlName='username'>
          </div>
        </div>

        <div class="input-group">
        <span class="input-group-addon">
          <i class="material-icons">lock</i>
        </span>
          <div class="form-group label-floating is-empty">
            <label class="control-label">New password</label>
            <input [type]="type" class="form-control" formControlName='newPassword' [popover]="popTemplate" triggers="input:focusout" placement="bottom"
            #pop="bs-popover" (input)="checkPasswordStrength($event.target.value)">
            <ng-template  #popTemplate >
              <div *ngIf="securityPolicyDetails" class="row" style="padding-left: 10px; padding-right: 10px;">
                <label>Password policy</label><br>
              </div>
              <div *ngIf="!securityPolicyDetails" class="row" style="padding-left: 10px; padding-right: 10px;">
                <label>No Password policy are loaded for this user</label><br>
              </div>

              <ng-container *ngIf="securityPolicyDetails">

                <div class="row" style="padding-left: 10px; padding-right: 10px;">
                  <div>
                    <i *ngIf="usernameContains"
                       class="material-icons" style="color:  green;">done</i>
                    <i *ngIf="!usernameContains" class="material-icons"
                       style="color: lightgrey;">clear</i>Should be different from the username</div>
                </div>

                <div *ngIf="securityPolicyDetails.security.usernameRestriction " class="row"
                     style="padding-left: 10px; padding-right: 10px;">
                  <div>
                    <i *ngIf="usernameChar" class="material-icons" style="color:  green;">done</i>
                    <i *ngIf="!usernameChar" class="material-icons" style="color: lightgrey;">clear</i>
                    Must not contain more than {{securityPolicyDetails.security.usernameCharacterNo}} characters from the user's name
                  </div>
                </div>
                <div class="row" style="padding-left: 10px; padding-right: 10px;">
                  <div>
                    <i *ngIf="this.passwordCharNumber == securityPolicyDetails.security.passwordMinCharacterNo || this.passwordCharNumber > securityPolicyDetails.security.passwordMinCharacterNo"
                       class="material-icons" style="color:  green;">done</i>
                    <i *ngIf="this.passwordCharNumber < securityPolicyDetails.security.passwordMinCharacterNo" class="material-icons"
                       style="color: lightgrey;">clear</i>
                    Minimum
                    {{securityPolicyDetails.security.passwordMinCharacterNo}} characters </div>
                </div>

                   <!-- new password policies -->
                   <div *ngIf="securityPolicyDetails.security.passwordSpaceRestriction " class="row"
                   style="padding-left: 10px; padding-right: 10px;">
                   <div>
                     <i *ngIf="!passwordContainsSpace" class="material-icons" style="color:  green;">done</i>
                     <i *ngIf="passwordContainsSpace" class="material-icons" style="color: lightgrey;">clear</i>
                     Must not contain spaces
                   </div>
                 </div>

                 <div class="row" *ngIf="securityPolicyDetails.security.passwordUsersNameRestriction" style="padding-left: 10px; padding-right: 10px;">
                   <div>
                     <i *ngIf="!passwordContainsNames" class="material-icons" style="color:  green;">done</i>
                     <i *ngIf="passwordContainsNames" class="material-icons" style="color: lightgrey;">clear</i>
                     Must not contains user’s name
                   </div>
                 </div>
                 <!-- end of new password policies -->

                <div class="row" style="padding-left: 10px; padding-right: 10px;"
                     *ngIf="securityPolicyDetails.security.passwordUpperCaseRestriction">
                  <i *ngIf="upperCaseNo == securityPolicyDetails.security?.passwordUpperCaseNo || upperCaseNo > securityPolicyDetails.security?.passwordUpperCaseNo"
                     class="material-icons" style="color: green;">done</i>
                  <i *ngIf="upperCaseNo < securityPolicyDetails.security?.passwordUpperCaseNo" class="material-icons"
                     style="color: lightgrey;">clear</i>
                  At least {{securityPolicyDetails.security?.passwordUpperCaseNo}} upper
                  case letter <br>
                </div>
                <div class="row" *ngIf="securityPolicyDetails.security.passwordLowerCaseRestriction"
                     style="padding-left: 10px; padding-right: 10px;">
                  <i *ngIf="lowerCaseNo == securityPolicyDetails.security?.passwordLowerCaseNo || lowerCaseNo > securityPolicyDetails.security?.passwordLowerCaseNo"
                     class="material-icons" style="color: green;">done</i>
                  <i *ngIf="lowerCaseNo < securityPolicyDetails.security?.passwordLowerCaseNo" class="material-icons"
                     style="color: lightgrey;">clear</i>
                  At least {{securityPolicyDetails.security?.passwordLowerCaseNo}}
                  lower case letter <br>
                </div>
                <div class="row" style="padding-left: 10px; padding-right: 10px;"
                     *ngIf="securityPolicyDetails.security.passwordNumberRestriction">
                  <div *ngIf="securityPolicyDetails.security?.passwordNumberNo == 1">
                    <i *ngIf="containsNo == securityPolicyDetails.security?.passwordNumberNo || containsNo > securityPolicyDetails.security?.passwordNumberNo"
                       class="material-icons" style="color: green;">done</i>
                    <i *ngIf="containsNo < securityPolicyDetails.security?.passwordNumberNo" class="material-icons"
                       style="color: lightgray;">clear</i>
                    Must contain number
                  </div>
                  <div *ngIf="securityPolicyDetails.security?.passwordNumberNo > 1">
                    <i *ngIf="containsNo == securityPolicyDetails.security?.passwordNumberNo || containsNo > securityPolicyDetails.security.passwordNumberNo"
                       class="material-icons" style="color: green;">done</i>
                    <i *ngIf="containsNo < securityPolicyDetails.security?.passwordNumberNo" class="material-icons"
                       style="color: lightgray;">clear</i>
                    Must contain at least {{securityPolicyDetails.security?.passwordNumberNo}} numbers
                  </div>
                </div>

                <div class="row" style="padding-left: 10px; padding-right: 10px;"
                     *ngIf="securityPolicyDetails.security.passwordSpecialCharRestriction">
                  <div *ngIf="securityPolicyDetails.security?.passwordSpecialCharNo == 1">
                    <i *ngIf="specialCharNo == securityPolicyDetails.security?.passwordSpecialCharNo || specialCharNo > securityPolicyDetails.security?.passwordSpecialCharNo"
                       class="material-icons" style="color: green;">done</i>
                    <i *ngIf="specialCharNo < securityPolicyDetails.security?.passwordSpecialCharNo" class="material-icons"
                       style="color: lightgray;">clear</i>
                    Must contain special character
                  </div>
                  <div *ngIf="securityPolicyDetails.security?.passwordSpecialCharNo > 1">
                    <i *ngIf="specialCharNo == securityPolicyDetails.security?.passwordSpecialCharNo || specialCharNo > securityPolicyDetails.security?.passwordSpecialCharNo"
                       class="material-icons" style="color: green;">done</i>
                    <i *ngIf="specialCharNo < securityPolicyDetails.security?.passwordSpecialCharNo" class="material-icons"
                       style="color: lightgray;">clear</i>
                    Must contain at least {{securityPolicyDetails.security?.passwordSpecialCharNo}} special character
                  </div>
                </div>

                <div class="row" style="padding-left: 10px; padding-right: 10px;"
                *ngIf="securityPolicyDetails.security?.customRules?.length > 0">
                <div>
                  <i *ngIf="customRulesValidation == true"
                    class="material-icons" style="color: green;">done</i>
                  <i *ngIf="customRulesValidation == false" class="material-icons"
                    style="color: lightgray;">clear</i>
                    Must match regular expression of custom rules
                  </div>
              </div>
              </ng-container>
            </ng-template>

          </div>

          <span *ngIf="type === 'password'" title="Show password" class="input-group-addon addon-right text-gray cursor-pointer" (click)="tooglePasswordMode('text', true)">
          <i class="mdi mdi-eye"></i>
        </span>
          <span *ngIf="type === 'text'" title="Hide password" class="input-group-addon addon-right text-gray cursor-pointer" (click)="tooglePasswordMode('password', true)">
          <i class="mdi mdi-eye-off"></i>
        </span>
        </div>

        <div class="input-group">
        <span class="input-group-addon">
          <i class="material-icons">lock</i>
        </span>
          <div class="form-group label-floating is-empty">
            <label class="control-label">Confirm new password</label>
            <input [type]="confType" class="form-control" formControlName='newPasswordConfirm'>
            <div class="text-danger" *ngIf = "passwordResetForm.valid && !passwordsAreEqual()">Passwords do not match</div>
          </div>
          <span *ngIf="confType === 'password'" title="Show password" class="input-group-addon addon-right text-gray cursor-pointer" (click)="tooglePasswordMode('text', false)">
          <i class="mdi mdi-eye"></i>
        </span>
          <span *ngIf="confType === 'text'" title="Hide password" class="input-group-addon addon-right text-gray cursor-pointer" (click)="tooglePasswordMode('password', false)">
          <i class="mdi mdi-eye-off"></i>
        </span>
        </div>
        <div class="text-center">
          <button [disabled] = '!passwordResetForm.valid || !passwordsAreEqual() || !passwordValidation' (click) = 'resetPasswordSubmit()' class="btn btn-primary"
                  [ngStyle]="{'background-color': this.sharedService?.ButtonColor?.value, 'color':  this.sharedService?.TextButtonColor?.value}"
          >Reset password</button>
        </div>

      </form>
    </ng-container>

  </div>

  <div class="footer text-center">
    <p class="small">
      <a routerLink="/login" routerLinkActive="active">
        Sign in with a different account</a>
    </p>
  </div>

</div>
<!----card end------>
